import { Link } from "react-router-dom";
import { NerdStackFooter } from "../components/NerdStackFooter.jsx";
import { ToolCard } from "../components/ToolCard.jsx";
import { ToolGrid } from "../components/ToolGrid.jsx";
import BackArrow from "../components/BackArrow.jsx";

// NerdHistory accents — aged brass / old gold → family violet (V55 lock).
const EM = "#C9A227";       // NerdHistory in-app accent (aged brass)
const EM_DEEP = "#7C3AED";  // family violet for the Hi badge gradient
const EM_LIGHT = "#EDD06B"; // light brass for gradient-text headings

const rgba = (hex, a) => {
  const r = parseInt(hex.slice(1, 3), 16), g = parseInt(hex.slice(3, 5), 16), b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${a})`;
};

// V55 first round — History Reference is the launch tool. Other history
// tools (timeline, primary source analyzer, etc.) come in a later iteration.
const TOOLS = [
  {
    name: "History Reference",
    path: "/history/reference",
    live: true,
    desc: "Ancient through 20th century — events, people, ideas, institutions — plus historiography, methods, and thematic threads. With quiz.",
  },
];

export default function HistoryHome() {
  return (
    <div style={{ minHeight: "100vh", background: "#0A0B14", fontFamily: "'DM Sans', system-ui, sans-serif", color: "#E2E8F0" }}>
      {/* Bottom-edge stretched glow — V45.3 cross-family consistency, V62.1.1 broadened from centered circle */}
      <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, height: "70%", background: `radial-gradient(ellipse at center bottom, ${rgba(EM, 0.18)} 0%, transparent 70%)`, pointerEvents: "none" }} />

      <header style={{
        display: "flex", justifyContent: "space-between", alignItems: "center",
        padding: "16px 24px",
        paddingTop: "calc(16px + env(safe-area-inset-top))",
        paddingLeft: "calc(24px + env(safe-area-inset-left))",
        paddingRight: "calc(24px + env(safe-area-inset-right))",
        position: "relative", zIndex: 10,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <BackArrow to="/" from={EM} toColor={EM_LIGHT} />
          <div style={{ width: 38, height: 38, borderRadius: 11, background: `linear-gradient(135deg, ${EM}, ${EM_DEEP})`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 19, fontWeight: 800, color: "#fff" }}>H</div>
          {/* SVG wordmark */}
          <svg width="135" height="24" viewBox="0 0 135 24" xmlns="http://www.w3.org/2000/svg" style={{ display: "block" }}>
            <defs>
              <linearGradient id="wm-history" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stopColor={EM_LIGHT} />
                <stop offset="1" stopColor="#D4B5A8" />
              </linearGradient>
            </defs>
            <text x="0" y="19" fill="url(#wm-history)" fontFamily="DM Sans, system-ui, sans-serif" fontSize="20" fontWeight="800" letterSpacing="-0.5">NerdHist</text>
          </svg>
        </div>
      </header>

      <main style={{ maxWidth: 820, margin: "0 auto", padding: "40px 20px 80px", position: "relative", zIndex: 10 }}>
        <h1 style={{ fontSize: "clamp(32px, 6vw, 52px)", fontWeight: 800, letterSpacing: "-1.5px", textAlign: "center", margin: "0 0 14px", lineHeight: 1.1 }}>
          History.<br /><span style={{ background: `linear-gradient(135deg, ${EM_LIGHT}, ${EM})`, WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>The patterns behind the dates.</span>
        </h1>
        <p style={{ fontSize: 17, color: "#9CA3AF", textAlign: "center", maxWidth: 580, margin: "0 auto 14px", lineHeight: 1.6 }}>
          333 items across ancient, medieval, early modern, modern, 20th century, and US history — plus historiography, methods, intellectual / economic / military / scientific threads, and historical-thinking concepts. With quiz.
        </p>
        <p style={{ fontSize: 15, color: "#6F7290", textAlign: "center", maxWidth: 580, margin: "0 auto 44px", lineHeight: 1.6 }}>
          Free. No signup. No dark patterns.
        </p>

        <ToolGrid>
          {TOOLS.map((t) => (
            <ToolCard
              key={t.name}
              to={t.live ? t.path : "/history"}
              name={t.name}
              desc={t.desc}
              accent={EM}
            />
          ))}
        </ToolGrid>
      </main>

      <footer style={{ textAlign: "center", padding: 24, fontSize: 12, color: "#1F2937", borderTop: `1px solid ${rgba(EM, 0.04)}` }}>
        <NerdStackFooter variant="tool" family="history" />
      </footer>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; }
        body { margin: 0; }
      `}</style>
    </div>
  );
}
